const services = [
    {
        id: 1,
        featured: 1,
        title: "turn key industrial projects",
        imgURL: "/images/services/turnkey-industrial-projects.webp",
    },
    {
        id: 2,
        featured: 2,
        title: "steel fabrication",
        imgURL: "/images/services/steel-fabrication.webp",
    },
    {
        id: 3,
        featured: 9,
        title: "steel & panels erection",
        imgURL: "/images/services/steel-panel.webp",
    },
    {
        id: 4,
        featured: 10,
        title: "steel works modifications",
        imgURL: "/images/services/steel-work-modifications.webp",
    },
    {
        id: 5,
        featured: 8,
        title: "fire paint system",
        imgURL: "/images/services/fire-paint.jpg",
    },
    {
        id: 6,
        featured: 12,
        title: "welding works",
        imgURL: "/images/services/welding-works.webp",
    },
    {
        id: 7,
        featured: 3,
        title: "engineering services",
        imgURL: "/images/services/engineering-services.webp",
    },
    {
        id: 8,
        featured: 4,
        title: "industrial flooring",
        imgURL: "/images/services/industrial-flooring.webp",
    },
    {
        id: 9,
        featured: 5,
        title: "steel miscellanies manufacturing in house",
        imgURL: "/images/services/steel-1.webp",
    },
    {
        id: 10,
        featured: 6,
        title: "anchor bolts & shear studs installation",
        imgURL: "/images/services/anchor-bolts-shear-stud.webp",
    },
    {
        id: 11,
        featured: 11,
        title: "racking system installation",
        imgURL: "/images/services/racking-system.webp",
    },
    {
        id: 12,
        featured: 7,
        title: "electromechanical works",
        imgURL: "/images/services/electro-mechanical.webp",
    }
];

export default services;